
// @ts-nocheck


export const localeCodes =  [
  "fr",
  "de"
]

export const localeLoaders = {
  fr: [
    {
      key: "locale_fr_46json_0b687afd",
      load: () => import("#nuxt-i18n/0b687afd" /* webpackChunkName: "locale_fr_46json_0b687afd" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_96bd13ad",
      load: () => import("#nuxt-i18n/96bd13ad" /* webpackChunkName: "locale_de_46json_96bd13ad" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "fr",
      language: "fr-FR",
      name: "Français",
      files: [
        {
          path: "/vercel/path0/i18n/locales/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      language: "de-DE",
      name: "Deutsch",
      files: [
        {
          path: "/vercel/path0/i18n/locales/de.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "fr",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "fg_lang_redirected",
    cookieSecure: false,
    fallbackLocale: "fr",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://www.fiscogest.lu",
  customRoutes: "config",
  pages: {
    index: {
      fr: "/",
      de: "/"
    },
    articles: {
      fr: "/articles",
      de: "/alle-artikel"
    },
    "particle/[slug]": {
      fr: "/article/[slug]",
      de: "/artikel/[slug]"
    },
    history: {
      fr: "/a-propos",
      de: "/ueber-uns"
    },
    jobs: {
      fr: "/emplois",
      de: "/jobs"
    },
    services: {
      de: "/dienstleistungen"
    },
    team: {
      fr: "/equipe",
      de: "/team"
    },
    testimonials: {
      fr: "/temoignages",
      de: "/erfahrungsberichte"
    },
    contact: {
      fr: "/contact",
      de: "/kontakt"
    },
    myfisco: {
      fr: "/myfisco",
      de: "/myfisco"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "fr",
    language: "fr-FR",
    name: "Français",
    files: [
      {
        path: "/vercel/path0/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    language: "de-DE",
    name: "Deutsch",
    files: [
      {
        path: "/vercel/path0/i18n/locales/de.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/